import { useScrollToTop } from "./hooks/useScrollToTop";

export const ScrollToTop = (): null => {
  useScrollToTop();
  return null;
};
